import { useSettingsStore } from "@/lib/settings";

export type NotificationSound =
  | "accountConnected"
  | "accountConnectFailed"
  | "orderSuccess";

const SOUND_URLS: Record<NotificationSound, string> = {
  accountConnected: "/sounds/account-connected-success.mp3",
  accountConnectFailed: "/sounds/account-connect-fail.mp3",
  orderSuccess: "/sounds/order-success.mp3",
};

export function playNotificationSound(sound: NotificationSound): void {
  if (!useSettingsStore.getState().getSetting("sound")) {
    return;
  }

  const audio = new Audio(SOUND_URLS[sound]);
  audio.play().catch(() => {});
}
